import type { ICall } from "../config";

export const callMock: ICall = {
  title: "Get started",
  subtitle: "Start using most powerful AI YouTube summary tool now.",
  btnText: "Get Started",
};
